exports = module.exports = require("../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.vux-label-desc {\n  font-size:14px;\n  color:#666;\n}\n", "", {"version":3,"sources":["D:/gitProject/im-H5/node_modules/vux/src/components/inline-desc/index.vue"],"names":[],"mappings":";AAWA;EACE,eAAe;EACf,WAAW;CACZ","file":"index.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n.vux-label-desc {\n  font-size:14px;\n  color:#666;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-526adabe","scoped":false,"hasInlineConfig":true}!./~/vux-loader/src/style-loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vux/src/components/inline-desc/index.vue
// module id = 232
// module chunks = 18